/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './ovulation.reducer';

export const OvulationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const ovulationEntity = useAppSelector(state => state.ovulation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="ovulationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.ovulation.detail.title">Ovulation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.ovulation.id">Id</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.id}</dd>
          <dt>
            <span id="estimatedStartDate">
              <Translate contentKey="tinyMedicRestApp.ovulation.estimatedStartDate">Estimated Start Date</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.estimatedStartDate}</dd>
          <dt>
            <span id="actualStartDate">
              <Translate contentKey="tinyMedicRestApp.ovulation.actualStartDate">Actual Start Date</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.actualStartDate}</dd>
          <dt>
            <span id="estimatedEndDate">
              <Translate contentKey="tinyMedicRestApp.ovulation.estimatedEndDate">Estimated End Date</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.estimatedEndDate}</dd>
          <dt>
            <span id="actualEndDate">
              <Translate contentKey="tinyMedicRestApp.ovulation.actualEndDate">Actual End Date</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.actualEndDate}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.ovulation.status">Status</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.status}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.ovulation.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.ovulation.active">Active</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.ovulation.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.ovulation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.ovulation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.ovulation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.ovulation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{ovulationEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.ovulation.event">Event</Translate>
          </dt>
          <dd>{ovulationEntity.event ? ovulationEntity.event.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/ovulation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/ovulation/${ovulationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OvulationDetail;
